import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import mailtoLink from './GetInTouchLink';
import GetInTouchLink from './GetInTouchLink';
import { useColorScheme } from '@mui/material';
import { AuthContext } from '../context/AuthContext';

const Sidebar = ({ isOpen }) => {

    const location = useLocation();
    const [isReportingOpen, setIsReportingOpen] = useState(false);
    const [isSupportOpen, setIsSupportOpen] = useState(false);
    const { userRole } = useContext(AuthContext);

    const isActive = useCallback((paths, exact = false) => {
        if (exact) {
            return paths.includes(location.pathname) ? 'active' : '';
        } else {
            return paths?.some(path => location.pathname.startsWith(path)) ? 'active' : '';
        }
    }, [location.pathname]);

    useEffect(() => {
        const reportingPaths = [
            '/dashboard/reporting/vehicle',
            '/dashboard/reporting/location',
            '/dashboard/reporting/mileage-rates'
        ];

        setIsReportingOpen(reportingPaths.includes(location.pathname));

        const supportPaths = [
            '/dashboard/support/terms',
            '/dashboard/support/about',
            '/dashboard/support/privacy',
            '/dashboard/support/contact'
        ]

        setIsSupportOpen(supportPaths.includes(location.pathname));
    }, [location.pathname]);

    return (
        <div className={`side-navbar ${isOpen ? 'side-hide' : ''}`}>
            <button className="closeBtn"><i className="fa-solid fa-times" /></button>
            <div className="sidebar-logo">
                <Link className="logo" to=''>
                    <img src="/assets/images/L2.svg" alt="Logo" />
                </Link>
            </div>
            <div className="side_menu_wrapper">
                <div className="sidemenu_list">
                    <span className="nvx">
                        <span className="nvx_dots">...</span>
                    </span>
                    <ul className="nav flex-column position-relative" id="sidebar-nav">
                        <li className="sidebar-link">
                            <Link to='/dashboard' className={`nav-link ${isActive(['/dashboard'], true)}`}>
                                <span className="menu-icon">
                                    <img src="/assets/images/dashboard2.svg" alt="Dashboard" />
                                </span>
                                <span className="menu_text">Dashboard</span>
                            </Link>
                        </li>
                    </ul>
                    <ul className="nav flex-column position-relative" id="sidebar-nav">
                        <li className="sidebar-link">
                            <Link to='/dashboard/user-management' className={`nav-link ${isActive(['/dashboard/user-management'], true)}`}>
                                <span className="menu-icon">
                                    <img src="/assets/images/usericon.svg" alt="Trips" />
                                </span>
                                <span className="menu_text">User Management</span>
                            </Link>
                        </li>
                        <li className="sidebar-link">
                            <Link to='/dashboard/quiz-management' className={`nav-link ${isActive(['/dashboard/quiz-management'], true)}`}>
                                <span className="menu-icon">
                                    <img src="/assets/images/quiz.svg" alt="Expenses" />
                                </span>
                                <span className="menu_text">Quiz Management</span>
                            </Link>
                        </li>
                        <li className="sidebar-link">
                            <Link to='/dashboard/subscription-management' className={`nav-link ${isActive(['/dashboard/subscription-management'], true)}`}>
                                <span className="menu-icon">
                                    <img src="/assets/images/subscription.svg" alt="Odometer" />
                                </span><span className="menu_text">Subscription Management</span>
                            </Link>
                        </li>
                        <li className="sidebar-link">
                            <Link to='/dashboard/term-conditions' className={`nav-link ${isActive(['/dashboard/term-conditions'], true)}`}>
                                <span className="menu-icon">
                                    <img src="/assets/images/terms.svg" alt="Reports" />
                                </span>
                                <span className="menu_text">Terms and Conditions</span>
                            </Link>
                        </li>
                        <li className="sidebar-link">
                            <Link to='/dashboard/send-notifications' className={`nav-link ${isActive(['/dashboard/send-notifications'], true)}`}>
                                <span className="menu-icon">
                                    <img src="/assets/images/notification.svg" alt="Reports" />
                                </span>
                                <span className="menu_text">Send Notifications</span>
                            </Link>
                        </li>
                        <li className="sidebar-link">
                            <Link to='/dashboard/upload-banner' className={`nav-link ${isActive(['/dashboard/upload-banner'], true)}`}>
                                <span className="menu-icon">
                                    <img src="/assets/images/Banner.svg" alt="banner" />
                                </span>
                                <span className="menu_text">Upload Banner</span>
                            </Link>
                        </li>
                        <li className="sidebar-link">
                            <Link to='/dashboard/quiz-support-tools' className={`nav-link ${isActive(['/dashboard/quiz-support-tools', '/dashboard/image-management'], true)}`}>
                                <span className="menu-icon">
                                    <img src="/assets/images/attach-icon.svg" alt="Upload" />
                                </span>
                                <span className="menu_text">Quiz Support Tools</span>
                            </Link>
                        </li>
                        <li className="sidebar-link">
                            <Link to='/dashboard/categories' className={`nav-link ${isActive(['/dashboard/categories'], true)}`}>
                                <span className="menu-icon">
                                    <img src="/assets/images/categorry.svg" alt="banner" />
                                </span>
                                <span className="menu_text">Categories</span>
                            </Link>
                        </li>
                        <li className="sidebar-link">
                            <Link to='/dashboard/support-management' className={`nav-link ${isActive(['/dashboard/support-management'], true)}`}>
                                <span className="menu-icon">
                                    <img src="/assets/images/notification1.svg" alt="Reports" />
                                </span>
                                <span className="menu_text">Support Management</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div >

    )
}

export default Sidebar
